<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.push({ name: 'settingsEntry' })">工作室设置</em>
          <label><i class="el-icon-arrow-right"></i> 修改认证信息</label>
        </div>
      </div>
      <div class="content-inner-wrap">
        <p class="updateTips">
          您正在进行重要操作，为保证您的数据安全，请验证您的手机号
        </p>
        <el-form :label-position="'right'" label-width="153px">
          <el-form-item label="手机号">
            <!-- <template v-if="hasPhone">{{ phoneNum }}</template> -->
            <el-input placeholder="请填写手机号" v-model="phoneNum" disabled>{{
              phoneNum
            }}</el-input>
            <!-- <el-input v-model="phoneForm.phone" disabled>{{
              phoneForm.phone
            }}</el-input> -->
          </el-form-item>
          <el-form-item label="验证码" class="code_item">
            <el-input
              class="code"
              placeholder="请填写验证码"
              v-model="verCode"
            ></el-input>
            <el-button
              :type="codeBtnType"
              size="mini"
              class="getCodeBtn"
              @click="getCode"
              :disabled="codeBtnStatus"
              >{{ codeBtnText }}</el-button
            >
          </el-form-item>
          <el-button
            class="largeCenterBtn"
            :type="submitBtnType"
            :class="{ disabled: disableSubmitBtn }"
            :disabled="disableSubmitBtn"
            @click="authCode"
            >确认</el-button
          >
        </el-form>
      </div>
      <el-dialog :visible.sync="openDialog" width="500px" :show-close="false">
        <div class="dialog-wrap">
          <div class="content">
            为了您的信息安全，请前往账号设置中绑定手机号
          </div>
          <el-button @click="routerPush" type="primary">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getVerCode, getStudioDetail } from '@/api/studio';
import { mapState } from 'vuex';
const ORG_CODE_BTN_TEXT = '获取验证码';
export default {
  data() {
    return {
      submitBtnType: 'primary',
      // submitBtnStatus: true,
      codeBtnType: 'primary',
      codeBtnStatus: true,
      openDialog: false,
      codeBtnText: ORG_CODE_BTN_TEXT,
      phoneNum: '',
      verCode: '',
      hasPhone: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
    disableSubmitBtn() {
      return !(
        this.phoneNum &&
        this.verCode &&
        this.isvalidPhone(this.phoneNum)
      );
    },
  },
  watch: {
    phoneNum: function (val) {
      if (this.isvalidPhone(val)) {
        this.setBtnEnable('code');
      } else {
        this.setBtnDisabled('code');
      }
    },
  },
  created() {
    let studioBaseInfo = JSON.parse(
      sessionStorage.getItem('studioBaseInfo') || '{}',
    );
    this.phoneNum = studioBaseInfo.phone;
    this.hasPhone = !!this.phoneNum;
    if (!this.hasPhone) {
      this.openDialog = true;
    }
  },
  methods: {
    isvalidPhone(str) {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
      return this.hasPhone || reg.test(str);
    },
    getCode() {
      if (this.codeBtnStatus) return;
      if (this.phoneNum && this.isvalidPhone(this.phoneNum)) {
        getVerCode({ phone: this.phoneNum, tk: this.userInfo.tk }).then(() => {
          this.setBtnDisabled('code');
          let seconds = 60;
          this.codeBtnText = seconds + 's';
          let timer = setInterval(() => {
            this.codeBtnText = --seconds + 's';
            if (seconds <= 0) {
              clearInterval(timer);
              timer = null;
              this.codeBtnText = ORG_CODE_BTN_TEXT;
              this.setBtnEnable('code');
            }
          }, 1000);
        });
      } else {
        this.$message.error('请正确输入手机号码');
      }
    },
    routerPush() {
      this.$router.push({ name: 'AccountSettings' });
    },
    authCode() {
      if (
        this.verCode &&
        this.phoneNum &&
        (this.hasPhone || this.isvalidPhone(this.phoneNum))
      ) {
        getStudioDetail({
          sms_code: this.verCode,
          phone: this.phoneNum,
          json: 1,
        }).then(res => {
          if (res.code === 0) {
            sessionStorage.setItem('studioBaseInfo', JSON.stringify(res.data));
            this.$router.push({
              name: 'settingsEntry',
              params: { activeName: 'vipInfo', jumpTabsChangeCheck: true },
            });
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        if (!this.verCode) {
          this.$message.error('请输入短信验证码');
        } else {
          this.$message.error('请填写手机号');
        }
      }
    },
    setBtnEnable(type) {
      this[type + 'BtnType'] = 'primary';
      this[type + 'BtnStatus'] = false;
    },
    setBtnDisabled(type) {
      this[type + 'BtnType'] = 'info';
      this[type + 'BtnStatus'] = true;
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .block {
    min-height: 800px;
    .content-inner-wrap {
      .el-form {
        width: 640px;
        margin: auto;
        ::v-deep .el-input__inner {
          width: 360px;
        }
        ::v-deep .el-form-item__content {
          margin-left: 181px !important;
        }
        .code_item {
          ::v-deep .el-form-item__content {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
          }
          .getCodeBtn {
            width: 120px;
            height: 32px;
            border-radius: 8px;
            font-size: 16px;
          }
        }
        .code {
          width: 219px;
          margin-right: 20px;
          ::v-deep .el-input__inner {
            width: 219px;
          }
        }
      }
      .updateTips {
        text-align: center;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #262626;
        line-height: 21px;
        margin: 59px auto 42px;
      }
      .largeCenterBtn {
        margin-top: 111px;
        &.disabled {
          opacity: 0.6;
        }
      }
    }
    .dialog-wrap {
      .content {
        font-size: 16px;
        text-align: center;
        margin-bottom: 30px;
      }
      .el-button {
        //  float: right;
        margin-left: 200px;
      }
    }
  }
}
</style>
